import api from './api';
import types from './mutation-types';

export default {
	getCommCodes_({ commit, state }, { key, codeType }) {
		state.searchParams.codeType = codeType;
		return api
			.getCommCodes(state.searchParams)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: key,
						value: data !== null && data !== undefined ? data.body : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},	
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	getBatchStatusList_({ commit, state }) {
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		const { searchParams, pagingInfo } = state;

		return api
			.getBatchStatusList({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					//console.log('데이터값은뭐냐>>>>>', data.body);

					commit(types.DEFAULT_ASSIGN, {
						key: 'batchStatusList',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});					
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}				
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	sendBatchStart_({ commit, state }, payload) {
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		return api
			.sendBatchStart(payload)
			.then(data => {
				if (data.header.code === 0) {
					//console.log(data.header.message);						
				}
				if (data.header.code === 1) {
					//console.log(data.header.message);					
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}				
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setBatchStatusList_({ commit }, param) {
		alert("액션");		
	}
};
